import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';

@Pipe({
  name: 'isSaveGeneralRoleDisabled',
})
export class IsSaveGeneralRoleDisabledPipe implements PipeTransform {
  transform(value: string): boolean {
    return isEmpty(value);
  }
}
